<template>
  <div class="scs-library-track">
    <base-list-item class="track-meta">
      <p class="track-name">{{ track["Name"] }}</p>
      <p class="track-artist">{{ track["Artist"] }}</p>
      <p class="track-time">{{ trackTime }}</p>
    </base-list-item>
    <round-button-with-icon
      v-if="plusSign"
      icon="plus"
      class="library-button"
      @click="plusSignClicked"
    />
  </div>
</template>
<script>
import BaseListItem from "../BaseListItem.vue";

import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";

export default {
  computed: {
    trackTime() {
      let m = Math.floor(this.track["Total Time"] / 60000);
      let s = Math.floor((this.track["Total Time"] / 1000) % 60).toLocaleString(
        "en-US",
        { minimumIntegerDigits: 2 }
      );
      return `${m}:${s}`;
    },
  },
  methods: {
    plusSignClicked() {
      this.$emit("plus-sign-clicked");
    },
  },
  components: {
    BaseListItem,
    RoundButtonWithIcon,
  },
  emits: ["plus-sign-clicked"],
  props: ["track", "plusSign"],
};
</script>
<style scoped>
.scs-library-track {
  display: flex;
  width: 100%;
  /* width: 100%; */
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  padding: 5px 0;
  box-sizing: border-box;
}

.track-meta {
  display: table;
  table-layout: fixed;
  justify-content: space-between;
  width: 100%;
  border-spacing: 5px;
}

.library-button {
  margin-left: 15px;
}

p {
  font-size: 0.65rem;
  width: 33%;
  max-width: 33%;
  display: table-cell;
  vertical-align: middle;
  font-weight: bold;
  white-space: nowrap;
  overflow: clip;
  text-overflow: ellipsis;
}

.track-name {
  text-align: left;
}

.track-artist {
  text-align: center;
}

.track-time {
  text-align: right;
}
</style>
